import React, { useState, useEffect, useRef } from "react";
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import './ExploreSection.css';
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";

const MyGallery = () => {
  const [images, setImages] = useState([]);
  const imgCDNURL = process.env.REACT_APP_RESOUND_CAROUSEL_IMG;
  let slides = [];

  const imageGalleryRef = useRef(null);

  useEffect(() => {
    async function fetchRelivePics() {
      try {
        const response = await axios.get(process.env.REACT_APP_RESOUND_CAROUSEL_JSON);
        console.log(response.data); // Ensure that the data is fetched correctly
        const memoryPicsData = response.data; // Assuming the JSON data is an array of objects
        for (const data of memoryPicsData) {
          const thumbnailURL = imgCDNURL + data.thumbnail;
          console.log('Thumbnail URL:', thumbnailURL);
          slides.push({
            key: data.key,
            original: thumbnailURL, // Assuming thumbnail URLs are used as originals
            thumbnail: thumbnailURL,
            url: data.url,
            originalClassoriginalClass: "gallery-image",
            thumbnailClass: "gallery-thumbnail",
            thumbnailLabel: data.thumbnailLabel,
          });
        }
        console.log('Slides:', slides); // Check if slides array is populated correctly
        setImages(slides);
      } catch (err) {
        console.log(err);
      }
    }
    fetchRelivePics();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (imageGalleryRef.current) {
        imageGalleryRef.current.slideToIndex(0, false);
      }
    }, 0);
  }, [images]);

  return (
    <div>
      <div className="grad1" />
      <Container>
        <Row className="">
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="Imageslide">
            <div className="gallery-container">
              <ImageGallery
                ref={imageGalleryRef}
                items={images}
                showThumbnails={true}
                showPlayButton={false}
                showBullets={false}
                showFullscreenButton={false}
                showNav={false}
                autoPlay={true}
                slideDuration={450}
                slideInterval={5000}
                onSlide={(index) => console.log(`Slid to ${index}`)}
                onErrorImageURL={'https://via.placeholder.com/150'}
                additionalClass="app-image-gallery"
                useWindowKeyDown={true}
                disableThumbnailScroll={false}
                isRTL={false}
                infinite={true}
                margin={0}
                lazyLoad={true}
                autoPlayinterval={6000}
                thumbnailLazyLoad={true}
                originalAlt="Image"
                thumbnailAlt="Thumbnail"
                originalTitle="Image Title"
                thumbnailTitle="Thumbnail Title"
                originalWidth={800}
                originalHeight={800}
                thumbnailWidth={250}
                thumbnailHeight={150}
                renderCustomControls={() => {
                  return <div></div>;
                }}
                renderItem={(item) => {
                  return (
                    <div className="image-gallery-custom-slide">
                      <a href={item.url} target="_blank" rel="noreferrer">
                        <img
                          srcSet={item.srcSet}
                          sizes={item.sizes}
                          src={item.original}
                          alt={item.originalAlt}
                          title={item.originalTitle}
                        />
                      </a>
                      {item.description && (
                        <span className="image-gallery-description">
                          {item.description}
                        </span>
                      )}
                    </div>
                  );
                }}
                thumbnailPosition="bottom" // Display thumbnails at the right
                thumbnailLabel={false}
                showIndex={true}
                startIndex={0}
                slideOnThumbnailHover={true}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <div className="grad2" />
    </div>
  );
};

export default MyGallery;
